import { render } from "./FbnSearch.vue?vue&type=template&id=cd67f49a"
import script from "./FbnSearch.vue?vue&type=script&lang=js"
export * from "./FbnSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__